<template>
  <div id="eventmoduleupdate-dialog" class="custom-modal">
    <transition name="el-fade-in" mode="out-in">
      <HolaconLottie v-if="loading == 'updateScreenLoading'" key="create-loading" />
      <el-row v-else key="content-loading">
        <div class="modal-body">
          <el-col :span="24">
            <el-button-group class="w-100 d-flex">
              <el-button :type="type == 0 ? 'primary' : 'default'" class="flex-grow-1" @click="type = 0" size="mini" round>{{ $t("eventInfo.modules.eventModuleUpdate.en") }}</el-button>
              <el-button :type="type == 1 ? 'primary' : 'default'" class="flex-grow-1" @click="type = 1" size="mini" round>{{ $t("eventInfo.modules.eventModuleUpdate.tr") }}</el-button>
            </el-button-group>
          </el-col>

          <transition name="el-fade-in" mode="out-in">
            <el-col :span="24" class="english" v-if="type == 0" key="english">
              <el-row :gutter="10">
                <el-col :span="24" class="mt-3">
                  <div class="registerform-input-container">
                    <div class="custom-label">
                      <label>{{ $t("eventInfo.modules.eventModuleUpdate.type") }}</label>
                    </div>
                    <el-select v-model="form.type">
                      <el-option v-for="(eventModuleType, index) in getEnums.find(x => x.title == 'EventModuleType').enums" :label="eventModuleType.displayName" :value="eventModuleType.key" :key="index"></el-option>
                    </el-select>
                    <span class="error">{{ $errorMessage("", validationErrors) }}</span>
                  </div>
                </el-col>
                <el-col :span="24" class="mt-3">
                  <div class="registerform-input-container">
                    <div class="custom-label">
                      <label>{{ $t("eventInfo.modules.eventModuleUpdate.title") }}</label>
                      <el-tooltip placement="top">
                        <div slot="content" class="custom-tooltip-content">
                          <span>{{ $t("eventInfo.modules.eventModuleUpdate.titleMsg") }}</span>
                        </div>
                        <i class="el-icon-info"></i>
                      </el-tooltip>
                    </div>
                    <el-input v-model="form.title" :class="$inputError('title', validationErrors)"></el-input>
                    <span class="error">{{ $errorMessage("", validationErrors) }}</span>
                  </div>
                </el-col>
                <el-col :span="24" class="mt-3" v-if="form.isCustom == true && form.type == 0">
                  <div class="registerform-input-container">
                    <div class="custom-label">
                      <label>{{ $t("eventInfo.modules.eventModuleUpdate.url") }}</label>
                      <el-tooltip placement="top">
                        <div slot="content" class="custom-tooltip-content">
                          <span>{{ $t("eventInfo.modules.eventModuleUpdate.urlMsg") }}</span>
                        </div>
                        <i class="el-icon-info"></i>
                      </el-tooltip>
                    </div>
                    <el-input v-model="form.url" :class="$inputError('url', validationErrors)">
                      <template slot="prepend">
                        https://
                      </template>
                    </el-input>
                  </div>
                </el-col>
                <el-col :span="24" class="mt-3" v-if="form.isCustom == true && form.type == 1">
                  <div class="registerform-input-container">
                    <div class="custom-label">
                      <label>{{ $t("eventInfo.modules.eventModuleUpdate.text") }}</label>
                      <el-tooltip placement="top">
                        <div slot="content" class="custom-tooltip-content">
                          <span>{{ $t("eventInfo.modules.eventModuleUpdate.textMsg") }}</span>
                        </div>
                        <i class="el-icon-info"></i>
                      </el-tooltip>
                    </div>
                    <quill-editor v-model="form.details" :options="editorOption" ref="myQuillEditor" @ready="onEditorReady($event)" :class="$inputError('details', validationErrors)"></quill-editor>
                  </div>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="24" class="turkish" v-else key="turkish">
              <el-row :gutter="10">
                <el-col :span="24" class="mt-3">
                  <div class="registerform-input-container">
                    <div class="custom-label">
                      <label>{{ $t("eventInfo.modules.eventModuleUpdate.type") }}</label>
                    </div>
                    <el-select v-model="form.type">
                      <el-option v-for="(eventModuleType, index) in getEnums.find(x => x.title == 'EventModuleType').enums" :label="eventModuleType.displayName" :value="eventModuleType.key" :key="index"></el-option>
                    </el-select>
                    <span class="error">{{ $errorMessage("", validationErrors) }}</span>
                  </div>
                </el-col>
                <el-col :span="24" class="mt-3">
                  <div class="registerform-input-container">
                    <div class="custom-label">
                      <label>{{ $t("eventInfo.modules.eventModuleUpdate.title") }}</label>
                      <el-tooltip placement="top">
                        <div slot="content" class="custom-tooltip-content">
                          <span>{{ $t("eventInfo.modules.eventModuleUpdate.titleMsg") }}</span>
                        </div>
                        <i class="el-icon-info"></i>
                      </el-tooltip>
                    </div>
                    <el-input v-model="form.titleTr" :class="$inputError('titleTr', validationErrors)"></el-input>
                  </div>
                </el-col>
                <el-col :span="24" class="mt-3" v-if="form.isCustom == true && form.type == 0">
                  <div class="registerform-input-container">
                    <div class="custom-label">
                      <label>{{ $t("eventInfo.modules.eventModuleUpdate.url") }}</label>
                      <el-tooltip placement="top">
                        <div slot="content" class="custom-tooltip-content">
                          <span>{{ $t("eventInfo.modules.eventModuleUpdate.urlMsg") }}</span>
                        </div>
                        <i class="el-icon-info"></i>
                      </el-tooltip>
                    </div>
                    <el-input v-model="form.url" :class="$inputError('url', validationErrors)">
                      <template slot="prepend">
                        https://
                      </template>
                    </el-input>
                  </div>
                </el-col>
                <el-col :span="24" class="mt-3" v-if="form.isCustom == true && form.type == 1">
                  <div class="registerform-input-container">
                    <div class="custom-label">
                      <label>{{ $t("eventInfo.modules.eventModuleUpdate.text") }}</label>
                      <el-tooltip placement="top">
                        <div slot="content" class="custom-tooltip-content">
                          <span>{{ $t("eventInfo.modules.eventModuleUpdate.urlMsg") }}</span>
                        </div>
                        <i class="el-icon-info"></i>
                      </el-tooltip>
                    </div>
                    <quill-editor v-model="form.detailsTr" :options="editorOption" :class="$inputError('detailsTr', validationErrors)" ref="myQuillEditor" @ready="onEditorReady($event)"></quill-editor>
                  </div>
                </el-col>
              </el-row>
            </el-col>
          </transition>

          <el-col class="mt-2" :span="24">
            <div class="custom-section-container">
              <div class="section-header" @click="settingsDock = !settingsDock">
                <div class="section-title">
                  <div class="section-head">
                    <label>{{ $t("eventInfo.modules.eventModuleUpdate.settings") }}</label>
                    <!-- <el-tooltip content="Content" placement="bottom">
                          <i class="el-icon-info"></i>
                        </el-tooltip> -->
                  </div>
                  <span>{{ $t("eventInfo.modules.eventModuleUpdate.settingsMsg") }}</span>
                </div>
                <div class="section-accordion">
                  <i class="fa" :class="settingsDock ? 'fa-angle-up' : 'fa-angle-down'"></i>
                </div>
              </div>
              <transition name="el-zoom-in-top">
                <div class="section-wrapper" v-show="settingsDock">
                  <div class="custom-set-container" :class="form.isActive ? 'sactive' : 'spassive'">
                    <div class="custom-set-inner">
                      <i class="fa" :class="form.isActive ? 'fa-eye' : 'fa-eye-slash'"></i>
                      <div class="custom-set-info">
                        <label>
                          {{ $t("eventInfo.modules.eventModuleUpdate.view") }}
                          <!-- <el-tooltip content="Content" placement="bottom">
                          <i class="el-icon-info"></i>
                        </el-tooltip> -->
                        </label>
                        <span>{{ $t("eventInfo.modules.eventModuleUpdate.viewMsg") }}</span>
                      </div>
                    </div>
                    <div class="custom-set-actions fend">
                      <el-switch v-model="form.isActive"></el-switch>
                    </div>
                  </div>
                  <div class="custom-set-container" :class="form.openInApp ? 'sactive' : ''" v-if="form.isCustom">
                    <div class="custom-set-inner">
                      <i class="fa" :class="form.openInApp ? 'fa-eye' : 'fa-eye-slash'"></i>
                      <div class="custom-set-info">
                        <label>
                          {{ $t("eventInfo.modules.eventModuleUpdate.openInApp") }}
                          <!-- <el-tooltip content="Content" placement="bottom">
                          <i class="el-icon-info"></i>
                        </el-tooltip> -->
                        </label>
                        <span>{{ $t("eventInfo.modules.eventModuleUpdate.openInAppMsg") }}</span>
                      </div>
                    </div>
                    <div class="custom-set-actions fend">
                      <el-switch v-model="form.openInApp"></el-switch>
                    </div>
                  </div>
                  <div class="custom-set-container" :class="form.isVisibleOnlyAttendees ? 'sactive' : 'swaiting'">
                    <div class="custom-set-inner">
                      <i class="fa" :class="form.isVisibleOnlyAttendees ? 'fa-eye' : 'fa-eye-slash'"></i>
                      <div class="custom-set-info">
                        <label>
                          {{ $t("eventInfo.modules.eventModuleUpdate.onlyAttendees") }}
                          <!-- <el-tooltip content="Content" placement="bottom">
                          <i class="el-icon-info"></i>
                        </el-tooltip> -->
                        </label>
                        <span>{{ $t("eventInfo.modules.eventModuleUpdate.onlyAttendeesMsg") }}</span>
                      </div>
                    </div>
                    <div class="custom-set-actions fend">
                      <el-switch v-model="form.isVisibleOnlyAttendees"></el-switch>

                      <div class="custom-set-action-inner" v-if="form.isVisibleOnlyAttendees" style="width:100%">
                        <div class="custom-set-action-inner">
                          <label>{{ $t("eventInfo.modules.eventModuleUpdate.tag") }}</label>
                          <el-tooltip placement="top">
                            <div slot="content" class="custom-tooltip-content">
                              <span>{{ $t("eventInfo.modules.eventModuleUpdate.tagMsg") }}</span>
                            </div>
                            <i class="el-icon-info"></i>
                          </el-tooltip>
                        </div>
                        <el-select v-model="form.tagIds" clearable @clear="form.tagIds = []" multiple filterable>
                          <el-option v-for="tag in tagList" :key="tag.id" :label="tag.title" :value="tag.id"></el-option>
                        </el-select>
                      </div>
                    </div>
                  </div>
                </div>
              </transition>
            </div>
          </el-col>
        </div>
      </el-row>
    </transition>

    <div class="modal-footer" slot="footer" v-if="loading != 'updateScreenLoading'">
      <div class="left-buttons">
        <el-button @click="$emit('closeDialog')">{{ $t("eventInfo.modules.eventModuleUpdate.close") }}</el-button>
        <template v-if="form.isCustom == true">
          <el-popconfirm @confirm="deleteItem" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="red" :title="$t('event.textbox.toDelete')">
            <el-button slot="reference" type="danger" icon="fas fa-trash">{{ $t("eventInfo.modules.eventModuleUpdate.delete") }}</el-button>
          </el-popconfirm>
        </template>
      </div>
      <div class="right-buttons">
        <el-button type="primary" @click="updated">{{ $t("eventInfo.modules.eventModuleUpdate.save") }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import axios from "axios";
import { quillEditor, Quill } from "vue-quill-editor";
import QuillResize from "quill-resize-module";
Quill.register("modules/resize", QuillResize);
export default {
  props: ["data"],
  components: {
    quillEditor
  },
  data() {
    return {
      axios,
      settingsDock: false,
      validationErrors: [],
      form: this.data,
      type: 0,
      loading: false,
      timeout: null,
      quill: null,
      quillUploading: false,
      editorOption: {
        modules: {
          toolbar: {
            container: [[{ size: ["small", false, "large", "huge"] }], ["bold", , "italic", "underline", "strike"], [{ indent: "-1" }, { indent: "+1" }], [{ color: [] }, { background: [] }], ["clean"], ["link", "image", "video"]],
            handlers: {
              image: () => {
                this.selectLocalImage();
              }
            }
          },

          syntax: {
            highlight: text => hljs.highlightAuto(text).value
          },

          resize: {
            modules: ["Resize"]
          }
        }
      }
    };
  },
  created() {
    this.loading = "updateScreenLoading";
    if (this.timeout != null) clearTimeout(this.timeout);
    this.timeout = setTimeout(async () => {
      await this.$store.dispatch("getTags");
      this.loading = false;
    }, 500);
  },
  methods: {
    onEditorReady(editor) {
      editor.root.setAttribute("data-placeholder", this.$t("enterText"));
      editor.getModule("toolbar").addHandler("image", () => {
        this.selectLocalImage(editor);
      });
    },
    selectLocalImage(editor) {
      const input = document.createElement("input");
      input.setAttribute("type", "file");
      input.click();
      input.onchange = () => {
        const file = input.files[0];
        if (/^image\//.test(file.type)) {
          this.saveToServer(file, editor);
          this.quillUploading = "Image upload process started.";
        } else {
          //console.warn("You could only upload images.");
          this.quillUploading = "You could only upload images.";
          setTimeout(() => {
            this.quillUploading = false;
          }, 3000);
        }
      };
    },
    insertToEditor(url, editor) {
      editor.insertEmbed(editor.getSelection().index, "image", url);
    },
    saveToServer(file, editor) {
      const fd = new FormData();

      fd.append("image", file);
      const xhr = new XMLHttpRequest();
      xhr.open("POST", axios.defaults.baseURL + "event/uploadImage?uploadType=html&language=" + this.$i18n.locale, true);
      xhr.setRequestHeader("Authorization", "Bearer " + localStorage.getItem("token"));

      xhr.onload = () => {
        if (xhr.status === 200) {
          const body = JSON.parse(xhr.responseText);
          console.log("body", body);
          if (body.alert.hasError == false) {
            const url = body.data.item.url;
            this.insertToEditor(url, editor);
            this.quillUploading = "Image upload process completed successfully.";
            setTimeout(() => {
              this.quillUploading = false;
            }, 3000);
          } else {
            this.$message.error(body.alert.message);
            this.quillUploading = body.alert.message;
            setTimeout(() => {
              this.quillUploading = false;
            }, 3000);
          }
        } else {
          this.quillUploading = xhr.statusText + " (Code: " + xhr.status + ")";
          setTimeout(() => {
            this.quillUploading = false;
          }, 3000);
        }
      };

      xhr.send(fd);
    },
    deleteItem() {
      this.$emit("deleteMe");
      this.$emit("closeDialog");
    },
    updated() {
      this.validationErrors = [];
      if (this.form.type == 1) {
        if (this.form.title == null || this.form.title == "") {
          this.validationErrors.push({ key: "title", value: this.$t("validation.plsFillThisField") });
        }
        if (this.form.titleTr == null || this.form.titleTr == "") {
          this.validationErrors.push({ key: "titleTr", value: this.$t("validation.plsFillThisField") });
        }
        if (this.form.details == null || this.form.details == "") {
          this.validationErrors.push({ key: "details", value: this.$t("validation.plsFillThisField") });
        }
        if (this.form.detailsTr == null || this.form.detailsTr == "") {
          this.validationErrors.push({ key: "detailsTr", value: this.$t("validation.plsFillThisField") });
        }
      } else {
        if ((this.form.url == null || this.form.url == "") && this.form.isCustom == true) {
          this.validationErrors.push({ key: "url", value: this.$t("validation.plsFillThisField") });
        }
      }

      if (this.validationErrors.length > 0) {
        this.$message.error(this.$t("validation.plsCheckThisField"));
        console.log(this.validationErrors);
        return;
      }
      this.$emit("updated", this.form);
    }
  },
  watch: {
    "form.type": function() {
      this.validationErrors = [];
    }
  },
  computed: {
    getEnums() {
      return this.$store.getters.getEnums;
    },
    tagList() {
      return this.$store.getters.getTagsList;
    }
  }
};
</script>

<style lang="less" scoped>
.event-info-page-module-update {
  padding: 1rem;
}
.registerform-input-container {
  .el-upload {
    width: 100% !important;
  }
  .tag-container {
    gap: 1rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
  .badge-list {
    display: flex;
    flex-direction: row;
    gap: 1rem;
    .badger {
      border-radius: 8px;
      background-color: #f3f3f3;
      height: 20px;
      padding: 10px;
    }
  }
  .title {
    i {
      cursor: pointer;
    }
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 0.5rem;
    gap: 0.3rem;
    label {
      font-weight: bold;
      color: black;
      margin-bottom: 0;
    }
    .title-container {
      display: flex;
      flex-direction: row;
      gap: 1rem;
      align-items: center;
    }
  }
  display: flex;
  flex-direction: column;
  .el-input-number {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/eventinfo/EventModuleUpdate.vue